<template>
<div>
    <van-popup v-model="contShow" round position="bottom" :style="{ height: '24rem',background:'#27282D' }">
        <div class="agreement_box">
            <div class="agreement_he">
                <div class="agreement_he_left">本场共计{{shopList.length}}件商品</div>
            </div>
            <div class="cp_boxtwo">
                <div class="outer-container">
                    <div class="inner-container">
                        <div class="content">
                            <template v-if="shopList.length==0">
                                <div class="none">
                                    <img src="../../../assets/img/none.png" alt="" />
                                    <p>暂无数据</p>
                                </div>
                            </template>
                            <template v-if="shopList.length>0">
                                <!-- <van-list center v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"> -->
                                <div v-for="(item) in shopList" :key="item.art_id" :title="item.title">
                                    <div class="cp_con">
                                        <div class="cp_list">
                                            <div class="cp_list_tu">
                                                <img :src="item.pics_little" alt="" @click="ppxq(item)" />
                                            </div>
                                            <div class="cp_list_con">
                                                <van-button type="primary" size="mini" class="cp_btn cp_btn_1" @click="chujia(item)">立即购买</van-button>
                                                <span class="jiages">￥ {{item.price}}</span>
                                                <div class="cp_list_name van-multi-ellipsis--l2" @click="ppxq(item)">{{item.goods_name}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- </van-list> -->
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </van-popup>
</div>
</template>

<script>
import {
    liveGoodsList
} from '@/api/live'; //商品列表
export default {
    props: ["shopShow", "liveData", "goodsList"],
    data() {
        return {
            contShow: this.shopShow, //显示
            loading: false,
            finished: false,
            shopList: [],
            tulus: this.tulu,
        };
    },
    components: {},
    created: function () {},
    mounted() {
        if (this.goodsList.length > 0) {
            this.shopList = this.goodsList;
            this.$forceUpdate()
        } else {
            this.getLiveGoodsList()
        }

    },
    methods: {
        getLiveGoodsList() { //商品列表
            if (this.contShow) {
                let obj = {
                    liveid: Number(this.$route.query.id), //直播id
                }
                liveGoodsList(obj).then((res) => {
                    this.shopList = res.data.list;
                })
            }
        },
        /* onLoad() {//拍卖中--加载更多
        },
        onLoadzt(loading,finished) {//拍卖中--加载更多状态
            this.loading = loading;
            this.finished = finished;
        }, */
        shopFun(show) {
            this.contShow = show;
        },
        // 跳转商品详情
        ppxq(item) {
            window.location.href = item.url
        },
        // 出价
        chujia(item) {
            if (this.liveData.isLogin == 0) {
                this.$parent.noLogin()
            } else if (this.liveData.isLogin == 1) {
                if(this.goodsList.length>0){
                    window.location.href=item.url
                }else{
                    this.$parent.offerOver('1', item);
                }
                
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.agreement_box {
    width: 100%;
    height: auto;
    padding: 0.6rem;
}

.agreement_he {
    width: 100%;
    overflow: hidden;
    line-height: 1.5rem;
}

.agreement_he_left {
    float: left;
    color: #fff;
    font-size: 0.8rem;
}

.cp_boxtwo {
    margin-top: 0.3rem;
}

// 滚动
.content,
.outer-container {
    width: 100%;
    height: 20rem;
}

.outer-container {
    position: relative;
    overflow: hidden;
    padding-bottom: 0.6rem;
}

.inner-container {
    width: 100%;
    position: absolute;
    left: 0;
    overflow-x: scroll;
    overflow-y: scroll;
}

.inner-container::-webkit-scrollbar {
    display: none;
}

// 解决滚动有部分隐藏了
/deep/ .van-list__finished-text {
    padding-bottom: 0.5rem;
}

/deep/ .van-list__loading {
    padding-bottom: 0.5rem;
}

.cp_box {
    width: 100%;
}

.cp_con {
    width: 100%;
    max-height: 20rem;
    overflow-x: hidden;
    overflow-y: auto;
    border-top: 1px solid #f7f7f7;
}

.cp_list {
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0.4rem 0rem;
    position: relative;
}

.cp_list_tu {
    width: 27%;
    height: 4.6rem;
    float: left;
    border-radius: 0.25rem;
    overflow: hidden;
}

.cp_list_tu img {
    width: 100%;
    height: 100%;
}

.cp_list_con {
    width: 70%;
    height: auto;
    float: right;
}

.cp_btn {
    position: absolute;
    right: 0px;
    border-radius: 0.6rem;
    padding: 0.2rem 0.5rem;
    margin-right: 0.4rem;
    z-index: 999;
}

.cp_btn_1 {
    background: #18BD6F;
    bottom: 0.6rem;
}

.cp_btn_2 {
    background: #FF5D4F;
    border: 1px solid #FF5D4F;
    top: 2.8rem;
}

.jiages {
    position: absolute;
    bottom: 0.6rem;
    left: 30%;
    color: #e6382f;
    font-size: 0.7rem;
}

.cp_list_name {
    width: 100%;
    line-height: 1.1rem;
    font-size: 0.8rem;
    color: #fff;
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
}

.cp_list_name span {
    display: inline-block;
    float: left;
    padding: 0rem 0.2rem;
    font-size: 0.5rem;
    border-radius: 0.2rem;
    color: #fff;
    margin-right: 0.2rem;
}

.cp_list_name .s1 {
    background: #e35458;
}

.cp_list_name .s2 {
    background: #18bd6f;
}

.cp_list_name .s3 {
    background: #656565;
}

.cp_list_nr {
    width: 100%;
    line-height: 1rem;
    font-size: 0.7rem;
    color: #969696;
    margin: 0.2rem 0rem;
}

.cp_list_nr .s11 {
    font-size: 0.5rem;
}

.cp_list_nr .ss {
    font-weight: bold;
}

.cp_list_nr .s11 {
    margin: 0px 0.2rem 0px 0.3rem;
}

.cp_list_nr1 .ss {
    color: #ff3b30;
}

.cp_list_nr2 .ss {
    color: #969696;
}

.cp_list_nr3 .ss {
    color: #27282d;
}

.cp_list_nr4 .ss {
    color: #18bd6f;
}
</style>
